<template>
  <div>
    <div class="bg-hrad">
      <div class="container">
        <div class="header-mcct">
          <img width="156px" height="42px" src="@/assets/img/mynextpay-white.svg" />
          <h2 class="text-transform text-white">Merchant cung cấp chứng từ</h2>
        </div>
      </div>
    </div>
    <section class="container">
      <div class="card py-10 pt-15 b-t-1-869fb229 w-100">
        <div class="card-body form-row" v-if="licenseDetail">
          <div class="col-sm-12 mb-2">
            <b-button size="sm" variant="light" class="mr-2" @click="licenseDetail = null"
              >Quay lại</b-button
            >
            <b-button
              v-if="['WAIT_OP_APPROVE', 'WAITE_DIRECTOR_APPROVE'].includes(licenseDetail.status)"
              size="sm"
              variant="success"
              class="mr-2"
              @click="approveLicense(licenseDetail.licenceId)"
              >Duyệt</b-button
            >
            <b-button
              v-if="['WAIT_OP_APPROVE', 'WAITE_DIRECTOR_APPROVE'].includes(licenseDetail.status)"
              size="sm"
              variant="danger"
              class="mr-2"
              @click="rejectLicense(licenseDetail.licenceId)"
              >Từ chối</b-button
            >
          </div>
          <div class="col-sm-6 mb-3">
            <div class="form-detail">
              <h1>Thông tin chung của MC</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên merchant<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.merchantInfo && licenseDetail.merchantInfo.name }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Email<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.merchantInfo && licenseDetail.merchantInfo.email }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Số điện thoại<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.merchantInfo && licenseDetail.merchantInfo.mobile }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >MST/ ĐKKD<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{
                      licenseDetail.merchantInfo &&
                      licenseDetail.merchantInfo.businessRegistrationNumber
                    }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Địa chỉ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.merchantInfo && licenseDetail.merchantInfo.addressBiz }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Điểm chấp nhận thanh toán<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12"
                    v-if="licenseDetail.merchantInfo && licenseDetail.merchantInfo.bizArea"
                  >
                    {{ licenseDetail.merchantInfo.bizArea.join(', ') }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Sale phát triển<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12"
                    v-if="licenseDetail.saleInfo && licenseDetail.saleInfo.name"
                  >
                    <span>{{ licenseDetail.saleInfo.name }}</span> -
                    <span> {{ licenseDetail.saleInfo.email }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <h1>Thông tin giao dịch MPOS</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã giao dịch MPOS<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.transInfo && licenseDetail.transInfo.tranTxnId }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại giao dịch<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.transInfo && licenseDetail.transInfo.tranTypeText }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Phương thức thanh toán<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.transInfo && licenseDetail.transInfo.paymentMethodText }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Trạng thái giao dịch<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  {{ licenseDetail.transInfo && licenseDetail.transInfo.statusText }}
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại rủi ro<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.requestTypeText }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <h1>Thông tin thẻ thanh toán</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên chủ thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.cardInfo && licenseDetail.cardInfo.holderName }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Số thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.cardInfo && licenseDetail.cardInfo.number }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label"
                  >Loại thẻ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ licenseDetail.cardInfo && licenseDetail.cardInfo.type }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 mb-3">
            <div class="img-list-wrapper">
              <h1 class="form-inner-heading">Upload thông tin chứng từ</h1>
              <div>
                <div>
                  <h1 class="form-inner-heading">1. Chứng từ liên quan đến giao dịch</h1>
                  <br />
                  <p>File PDF, ghi âm, video, ...</p>
                  <div class="form-group img-list">
                    <div
                      v-for="(item, index) in transFile"
                      :key="index"
                      style="background-color: #f5f5f5"
                    >
                      <div class="box-header">
                        <a :href="item.name" target="_blank">
                          <b
                            class="text-primary d-inline-block"
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              width: 90%;
                            "
                            >{{ item.name }}</b
                          >
                        </a>
                      </div>
                    </div>
                  </div>

                  <p>File ảnh</p>
                  <div class="form-group img-list">
                    <ul class="m-0" v-viewer>
                      <li v-for="(item, index) in transImage" :key="index">
                        <a href="javascript:void(0)">
                          <img :src="item.url" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h1 class="form-inner-heading">2. Chứng từ liên quan đến thông tin chủ thẻ</h1>
                  <p>File PDF, ghi âm, video, ...</p>
                  <div class="form-group img-list">
                    <div
                      v-for="(item, index) in cardFile"
                      :key="index"
                      style="background-color: #f5f5f5"
                    >
                      <div class="box-header">
                        <a :href="item.name" target="_blank">
                          <b
                            class="text-primary d-inline-block"
                            style="
                              white-space: nowrap;
                              text-overflow: ellipsis;
                              overflow: hidden;
                              width: 90%;
                            "
                            >{{ item.name }}</b
                          >
                        </a>
                      </div>
                    </div>
                  </div>
                  <p>File ảnh</p>
                  <div class="form-group img-list">
                    <ul class="m-0" v-viewer>
                      <li v-for="(item, index) in cardImage" :key="index">
                        <a href="javascript:void(0)">
                          <img :src="item.url" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body form-row mb-3" v-else>
          <b-table
            sticky-header
            hover
            responsive
            :items="licenseData"
            :fields="fieldsTable"
            :bordered="true"
          >
            <template #cell(time)="data">
              <p><b>Tạo</b>: {{ data.item.createdTime }}</p>
              <p><b>Cập nhật</b>: {{ data.item.updateAt | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
              <p v-if="data.item.transInfo.approvedAt">
                <b>Duyệt</b>: {{ data.item.transInfo.approvedAt }}
              </p>
              <p><b>Thanh toán</b>: {{ data.item.transInfo && data.item.transInfo.tranDate }}</p>
            </template>
            <template #cell(amount)="data">
              {{ data.item.transInfo && data.item.transInfo.amount | transformMoney }}
            </template>
            <template #cell(merchant)="data">
              {{ data.item.merchantInfo.name }}
            </template>
            <template #cell(saleAssign)="data">
              <div v-if="data.item.assigneeInfo.name">
                {{ data.item.assigneeInfo.name }} <br />
                <span class="text-primary">{{ data.item.assigneeInfo.email }}</span>
              </div>
            </template>
            <template #cell(nameTrans)="data">
              {{ data.item.transInfo.holderName }}
            </template>
            <template #cell(idTrans)="data">
              {{ data.item.transInfo.tranTxnId }}
            </template>
            <template #cell(isMerchantUpload)="data">
              {{ data.item.isMerchantUpload === true ? 'đã upload CT' : 'Chưa upload CT' }}
            </template>
            <template #cell(sttTrans)="data">
              {{ data.item.transInfo.status | transformData(Config.transactionStt) }}
            </template>
            <template #cell(status)="data">
              <span class="badge" :class="[data.item.status ? data.item.status : '']">
                {{ data.item.status | transformData(Config.licenceStt) }}
              </span>
            </template>
            <template #cell(action)="data">
              <b-button size="sm" variant="light" @click="getDetailMerchant(data.item.licenceId)">
                Chi tiết
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <div class="bg-ef">
      <div class="container">
        <div class="footer-mcct">
          <p class="t">CÔNG TY CỔ PHẦN CÔNG NGHỆ VIMO</p>
          <p class="i">
            <i>Tầng 12A, toà nhà VTC Online, số 18 Tam Trinh, Phường Tương Mai, Hà Nội</i>
          </p>
          <p class="i"><i>Hotline: 1900.63.69.56 | Email: hotro@nextpay.vn</i></p>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { LicenceService } from '@/services/licence.service'
  import Config from '@/thirdParty/config'
  const fieldsTable = [
    { key: 'time', label: 'Thời gian' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'saleAssign', label: 'NV xử lý' },
    { key: 'nameTrans', label: 'Tên chủ thẻ' },
    { key: 'idTrans', label: 'ID giao dịch', class: 'text-center' },
    { key: 'sttTrans', label: 'Trạng thái giao dịch' },
    { key: 'isMerchantUpload', label: 'MC upload CT' },
    { key: 'riskTypeText', label: 'Loại rủi ro' },
    { key: 'status', label: 'Trạng thái YCCT' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        fieldsTable,
        Config,
        licenseDetail: null,
        licenseData: [],
        showLoading: false,
        fileUploads: [],
      }
    },
    computed: {
      transFile: vm => vm.fileUploads.filter(s => s.type === 'transFile'),
      transImage: vm => vm.fileUploads.filter(s => s.type === 'transImage'),
      cardFile: vm => vm.fileUploads.filter(s => s.type === 'cardFile'),
      cardImage: vm => vm.fileUploads.filter(s => s.type === 'cardImage'),
    },
    methods: {
      async approveLicense(licenceId) {
        const flag = await this.approveMx('Bạn có chắc chắn duyệt chứng từ trên?')
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await LicenceService.mposApprove({
              licenceId,
              validKey: this.$route.query.token,
              note: '',
            })
            if (res.success === true) {
              await this.verifyLicense()
              if (this.licenseDetail.id && this.licenseData.length > 1) {
                this.getDetailMerchant(this.licenseDetail.id)
              }
              this.showSuccessMx('Duyệt chứng từ thành công!')
            } else this.showFailMx(res.message)
          } catch (error) {
          } finally {
            this.showLoading = false
          }
        }
      },
      async rejectLicense(licenceId) {
        const { value: flag, note } = await this.rejectMx()
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await LicenceService.mposReject({
              licenceId,
              validKey: this.$route.query.token,
              note,
            })
            if (res.success === true) {
              await this.verifyLicense()
              if (this.licenseDetail.id && this.licenseData.length > 1) {
                this.getDetailMerchant(this.licenseDetail.id)
              }
              this.showSuccessMx('Từ chối chứng từ thành công!')
            } else this.showFailMx(res.message)
          } catch (error) {
          } finally {
            this.showLoading = false
          }
        }
      },
      async verifyLicense() {
        try {
          this.showLoading = true
          const res = await LicenceService.listByTrans(
            this.$route.query.transactionTxnId,
            this.$route.query.token
          )
          this.licenseData = res.data
          if (res.data.length === 1) this.getDetailMerchant(res.data[0].licenceId)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getDetailMerchant(id) {
        this.licenseDetail = this.licenseData.find(s => s.licenceId === id)
        this.fileUploads = []
        const mappingData = (arr, type) =>
          arr.forEach(url => {
            const ar = { name: url, url, type }
            this.fileUploads.push(ar)
          })
        mappingData(this.licenseDetail.licenceTransactionUrls, 'transFile')
        mappingData(this.licenseDetail.licenceTransactionUrlsImg, 'transImage')
        mappingData(this.licenseDetail.licenceCardOwnerUrls, 'cardFile')
        mappingData(this.licenseDetail.licenceCardOwnerUrlsImg, 'cardImage')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header-mcct {
    padding: 25px 0;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    h2 {
      font-size: 32px;
      text-align: center;
    }
    img {
      display: none;
    }
  }
  .bg-hrad {
    background-color: #3979b5;
  }
  .bg-ef {
    background-color: #efefef;
  }
  .footer-mcct {
    padding: 25px 0;
    display: flex;
    flex-direction: column;
    p {
      line-height: normal;
    }
    .i {
      font-size: 11px;
    }
  }
  @media (min-width: 768px) {
    .header-mcct {
      img {
        display: block;
      }
      h2 {
        font-size: 36px;
      }
    }
  }
</style>
